import {Singleton} from 'app/utils';
import { Application } from 'app/classes';

interface IConstants {
    env: string;
    version: string;
    buildUrl: string;
    platformDomain: string;
    apps: Array<any>;
    raven: {
        dsn: string;
    };
    intercom: string;
    ga: {
        domain: string;
        appId: string;
    };
    cdnAssets: string;
    appIcons: string;
    emailTemplates: string;
}

export let $Constants: IConstants = Singleton('$Constants', Object);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/constants/constants.ts